'use strict';

var KayleeBase = require('./KayleeBase');
var KayleeUtil = require('./KayleeUtil');
var log = require('../log/Log').channel('KayleeConnectionState');

var connectedRef = null;
var connected = false;
var connectionStateListeners = [];
var firstTime = true;
var isWorkingOnline = true;
var offlineTimeoutMs = 0; // set to > 0 to automatically go offline if FirebaseObject.$set times out
var workingOnlineListeners = [];
var connectionStateChangedTimeout = null;
var savedConnectionState;

var KayleeConnectionState = {
    getOfflineTimeoutMs: function() { return offlineTimeoutMs; },
    isConnected: function() { return connected; },
    isWorkingOnline: function() { return isWorkingOnline; },
    onConnectionStateChanged: onConnectionStateChanged,
    onWorkingOnlineChanged: onWorkingOnlineChanged,
    offConnectionStateChanged: offConnectionStateChanged,
    offWorkingOnlineChanged: offWorkingOnlineChanged,
    setConnected: setConnected,
    setOfflineTimeoutMs: function(timeoutMs) { 
        log.info('setting offline timeout to ' + timeoutMs + ' ms');
        offlineTimeoutMs = timeoutMs;
    },
    setWorkingOnline: setWorkingOnline,
};

function onConnectionStateChanged(listener) {
    connectionStateListeners.push(listener);

    if (connectedRef === null) {
        connectedRef = KayleeBase.app.database().ref('.info/connected');
        connectedRef.on('value', internalOnConnectionStateChanged);
        // listeners will automatically be notified of the current value due to registration
    } else {
        listener(connected);
    }

    return listener;
}

function onWorkingOnlineChanged(listener) {
    workingOnlineListeners.push(listener);
    listener(isWorkingOnline);
    return listener;
}

function offConnectionStateChanged(listener) {
    for (var i = 0; i < connectionStateListeners.length; i++) {
        if (connectionStateListeners[i] === listener) {
            connectionStateListeners.splice(i, 1);
            break;
        }
    }
}

function offWorkingOnlineChanged(listener) {
    for (var i = 0; i < workingOnlineListeners.length; i++) {
        if (workingOnlineListeners[i] === listener) {
            workingOnlineListeners.splice(i, 1);
            break;
        }
    }
}

function internalOnConnectionStateChanged(snap) {
    if (connectionStateChangedTimeout !== null) {
        KayleeUtil.clearTimeout(connectionStateChangedTimeout);
    }

    savedConnectionState = snap.val();
    log.info(savedConnectionState ? 'connected to database' : 'disconnected from database');

    connectionStateChangedTimeout =
        KayleeUtil.setTimeout(onConnectionStateChangedTimeout, 3000);
}

function onConnectionStateChangedTimeout() {
    connectionStateChangedTimeout = null;

    if (firstTime || connected !== savedConnectionState) {
        firstTime = false;
        connected = savedConnectionState;
        log.info('reporting connected = ' + connected);

        connectionStateListeners.forEach(function(listener) {
            listener(connected);
        });
    }
}

function setConnected(connected) {
    if (KayleeBase.app === null) return;
    if (connected) {
        KayleeBase.app.database().goOnline();
    } else {
        KayleeBase.app.database().goOffline();
    }
}

function setWorkingOnline(online) {
    if (online !== isWorkingOnline) {
        isWorkingOnline = online;

        for (var i = 0; i < workingOnlineListeners.length; i++) {
            workingOnlineListeners[i](isWorkingOnline);
        }
    }
}

module.exports = KayleeConnectionState;
